import BaseHTMLColumnStrategy from './BaseHTMLColumnStrategy'

export default function BSHtmlNullTasksStrategy() {}

BSHtmlNullTasksStrategy.prototype = new BaseHTMLColumnStrategy();

BSHtmlNullTasksStrategy.prototype.getLevelsNumber = function () {
    return 0;
};

BSHtmlNullTasksStrategy.prototype.addFirstHeaderRowCells = function ( row, levelsNumber ) {
    // do nothing
};

BSHtmlNullTasksStrategy.prototype.addSecondHeaderRowCells = function ( row, levelsNumber ) {
    // do nothing
};

BSHtmlNullTasksStrategy.prototype.addColumnValueCells = function ( row ) {
    // do nothing
};





// WEBPACK FOOTER //
// ./web/js/reports/preview/html/billingsummary/BSHtmlNullTasksStrategy.js